




import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import dataShare from "../mall/dataShare";
declare let AMap: any;
declare let AMapUI: any;
@Component({
  name: "amap",
  components: {},
})
export default class amap extends Vue {
  @Prop({ default: false })
  autoLocation!: boolean;

  //data
  lat = "";
  lng = "";
  nowAddress: any = "";
  options = {
    enableHighAccuracy: true,
    buttonOffset: new AMap.Pixel(10, 20),
    zoomToAccuracy: true,
    panToLocation: true,
    showButton: false,
    showMarker: true,
    showCircle: false,
    useNative: true,
  };
  AcquisitionPoint: any = null;
  picklocationOnoff = true;
  //computed
  //beforeCreated
  beforeCreated() {}

  //created
  created() {
    // setTimeout(function() {
    //   __self.initMap();
    // }, 200);
  }

  //beforeMount
  beforeMount() {}

  //mounted
  mounted() {
    this.$nextTick(() => this.initMap());
  }
  setCenter(position: any) {
    console.log(position)
    this.map.setCenter(new AMap.LngLat(position.lng, position.lat));
  }
  //methods
  // 初始化地图
  map: any = "";
  initMap() {
    var __self = this;
    let container = this.$refs["container"];
    __self.map = new AMap.Map(container, {
      resizeEnable: true,
      zoom: 15.2,
      showIndoorMap: false,
      mapStyle: "amap://styles/5b5d2e8e958a60b0e2085a7748ad5c4e",
    });
    // __self.map.setMapStyle("amap://styles/5b5d2e8e958a60b0e2085a7748ad5c4e");
    if (this.autoLocation) {
      setTimeout(() => {
        __self.currentloca();
      }, 300);
    }
  }
  // 获取当前位置
  geolocation: any = "";
  currentloca() {
    var __self = this;
    AMap.plugin("AMap.Geolocation", function() {
      if (!__self.geolocation) {
        __self.geolocation = new AMap.Geolocation(__self.options);
      }
      __self.map.addControl(__self.geolocation);
      __self.geolocation.getCurrentPosition(function(status: any, result: any) {
        //error
        if (result.status == 0 && result.message == "Get sdkLocation failed.Geolocation permission denied.") {
          sessionStorage.setItem("NoPermission", "true");
          __self.picklocationOnoff = false;
        } else if (result.status == 0 && result.message == "Get sdkLocation failed.Get geolocation success.Convert Success.Get address success.") {
          sessionStorage.setItem("NoPermission", "true");
          __self.picklocationOnoff = false;
        } else if (result.status == 0 && result.message == "Geolocation permission denied.") {
          sessionStorage.setItem("NoPermission", "true");
          __self.picklocationOnoff = false;
        } else if (result.status == 0 && result.message == "Get ipLocation failed.Geolocation permission denied.") {
          sessionStorage.setItem("NoPermission", "true");
          __self.picklocationOnoff = false;
        }
        // success
        if (status == "complete") {
          __self.positionPicker();
          // __self.$emit("goBackimg", false);
        }
      });
    });
  }
  // 拖拽选址
  pickerPosition: any = "";
  positionPicker() {
    var __self = this;
    // 推荐使用AMapUI.loadUI接口加载特定UI
    AMapUI.loadUI(["misc/PositionPicker"], function(PositionPicker: any) {
      if (__self.pickerPosition) {
        __self.map.remove(__self.pickerPosition);
      } else {
        __self.pickerPosition = new PositionPicker({
          mode: "dragMap", //设定为拖拽地图模式，可选'dragMap'、'dragMarker'，默认为'dragMap'
          map: __self.map,
          iconStyle: {
            //自定义外观
            url: require("../../../static/img/baseMarker.png"), //图片地址
            ancher: [15, 30], //要显示的点大小，将缩放图片
            size: [30, 39], //锚点的位置，即被size缩放之后，图片的什么位置作为选中的位置
          },
        });
      }
      // 成功获取到了拖拽结束点的有效地址和周边信息时触发
      __self.pickerPosition.on("success", function(positionResult: any) {
        __self.lat = positionResult.position.lat;
        __self.lng = positionResult.position.lng;
        __self.nowAddress = positionResult;
        __self.$emit("setAddressData", positionResult);
        if (__self.AcquisitionPoint) __self.map.remove(__self.AcquisitionPoint);
        __self.$emit("textFun", "正在获取当前位置...");

        if (sessionStorage.getItem("NoPermission") == "false") {
          __self.AcquisitionPoint = new AMap.Text({
            text: '<div class="getCarInfo">\u6B63\u5728\u83B7\u53D6\u4E0A\u8F66\u70B9</div>',
            anchor: "center",
            cursor: "pointer",
            offset: new AMap.Pixel(0, -45),
            position: [__self.lng, __self.lat],
          });
          setTimeout(function() {
            __self.AcquisitionPoint.setMap(__self.map);
          }, 150);
        }

        //悦行调用了一个查询推荐上车点的api
        //   __self.getincar(__self.lng, __self.lat, "siccessPicker", positionResult);
        __self.picklocation();
      });

      // 获取不到拽结束点的有效地址和周边信息时触发
      __self.pickerPosition.on("fail", function(positionResult: any) {});

      var onModeChange = function onModeChange(e: any) {
        __self.pickerPosition.setMode(e.target.value);
      };

      __self.pickerPosition.start();
      __self.map.panBy(0, 1);
    });
  }

  // 位置选择
  markerText: any = "";
  picklocation(val?: any) {
    var __self = this;
    var texts = "正在获取上车点";
    if (__self.picklocationOnoff == false) texts = "无定位权限";

    if (__self.picklocationOnoff) {
      __self.markerText = new AMap.Text({
        text: '<div class="getCarInfo">'.concat(texts, "</div>"),
        anchor: "center",
        cursor: "pointer",
        offset: new AMap.Pixel(0, -45),
        position: [__self.lng, __self.lat],
      });
      __self.markerText.setMap(__self.map);
    } else {
      setTimeout(function() {
        __self.markerText = new AMap.Text({
          text: '<div class="getCarInfo">'.concat(texts, "</div>"),
          anchor: "center",
          cursor: "pointer",
          offset: new AMap.Pixel(0, -45),
          position: [__self.lng, __self.lat],
        });
        __self.markerText.setMap(__self.map);
      }, 1000);
    }

    if (__self.picklocationOnoff) {
      if (true) {
        setTimeout(function() {
          __self.map.remove(__self.markerText);
          __self.map.remove(__self.AcquisitionPoint);
          __self.markerText = new AMap.Text({
            text: '<div class="getCarInfo">'.concat(__self.nowAddress.address, "</div>"),
            anchor: "center",
            cursor: "pointer",
            offset: new AMap.Pixel(0, -45),
            position: [__self.lng, __self.lat],
          });
          __self.markerText.setMap(__self.map);
        }, 840);
      }
    }
    __self.map.on("mapmove", function() {
      if (__self.markerText != null) __self.map.remove(__self.markerText);
      if (__self.AcquisitionPoint) __self.map.remove(__self.AcquisitionPoint);
    });
  }

  // getData(data1: any, data2: any) {
  //   this.planning(data1, data2);
  // }

  driving: any = "";
  planning(data1: any, data2: any) {
    let __self = this;
    // if (__self.map == "") {
    //   __self.initMap();
    // }
    AMap.plugin("AMap.Driving", function() {
      var drivingOption = {
        policy: AMap.DrivingPolicy.LEAST_TIME,
        map: __self.map,
      };
      if (__self.driving) {
        __self.driving.clear();
      }
      // 构造路线导航类
      __self.driving = new AMap.Driving(drivingOption);
      // 根据起终点经纬度规划驾车导航路线
      __self.driving.search(new AMap.LngLat(data1.longitude, data1.latitude), new AMap.LngLat(data2.longitude, data2.latitude), function(status: any, result: any) {
        if (status === "complete") {
          __self.drawRoute(result.routes[0]);
        }
      });
    });
  }
  // 解析路径
  parseRouteToPath(route: any) {
    var path = [];
    for (var i = 0, l = route.steps.length; i < l; i++) {
      var step = route.steps[i];

      for (var j = 0, n = step.path.length; j < n; j++) {
        path.push(step.path[j]);
      }
    }
    return path;
  }
  // 绘制路线
  drawRoute(route: any) {
    let __self = this;
    setTimeout(() => {
      __self.map.clearMap(); // 清除地图覆盖物
      // 供应商状态
      var path = __self.parseRouteToPath(route);
      var startMarker = new AMap.Marker({
        position: path[0],
        map: this.map,
        content: " ",
      });
      var endMarker = new AMap.Marker({
        position: path[path.length - 1],
        map: this.map,
        content: " ",
      });
      var routeLine = new AMap.Polyline({
        path: path,
        showDir: true,
        isOutline: true,
        outlineColor: "#1E1E1E",
        borderWeight: 0.5,
        strokeWeight: 5,
        strokeColor: "#00BB2B",
        lineJoin: "round",
        lineCap: "round",
      });

      var startIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image: require("../../../static/img/qidian.png"),
        imageSize: new AMap.Size(22, 32),
        imageOffset: new AMap.Pixel(2, 2),
      });
      var startFromIcon = new AMap.Marker({
        position: new AMap.LngLat(path[0]["lng"], path[0]["lat"]),
        icon: startIcon,
        offset: new AMap.Pixel(-13, -30),
      });

      var endIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image: require("../../../static/img/zhongdi.png"),
        imageSize: new AMap.Size(22, 32),
        imageOffset: new AMap.Pixel(2, 2),
      });
      var endFromIcon = new AMap.Marker({
        position: new AMap.LngLat(path[path.length - 1]["lng"], path[path.length - 1]["lat"]),
        icon: endIcon,
        offset: new AMap.Pixel(-13, -30),
      });
      this.map.add([startFromIcon, endFromIcon]);

      routeLine.setMap(__self.map);
      // 缩放地图到合适的视野级别
      __self.map.setFitView([startMarker, endMarker, routeLine]);
      // 将折线添加至地图实例
      // __self.map.add(routeLine);
    }, 1000);
  }

  //beforeUpdate
  beforeUpdate() {}

  //updated
  updated() {}

  //activated
  activated() {}

  //deactivated
  deactivated() {}

  //beforeDestroy
  beforeDestroy() {}

  //destroyed
  destroyed() {}
}
